// extracted by mini-css-extract-plugin
export var hamburger = "Burger-module--hamburger--ae1de";
export var hamburgerBox = "Burger-module--hamburger-box--0f297";
export var hamburgerInner = "Burger-module--hamburger-inner--462ad";
export var isActive = "Burger-module--is-active--e7734";